export const appendChildToMap = (mapRef, children) => mapRef.append(children);